import { useEffect } from 'react'
import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { Center, Spinner } from '@chakra-ui/react'

const Home: NextPage = () => {
  const router = useRouter()
  useEffect(() => {
    router.push('/spotwork_jobs')
  })
  return (
    <Center height="100vh">
      <Spinner />
    </Center>
  )
}

export default Home
